import DistributorSVG from '../../assets/svg/distributor.svg';
export default DistributorSVG;
